<th [width]="width" [align]="align">
  <ng-content></ng-content>
</th>
